import { render, staticRenderFns } from "./ClientJobs.vue?vue&type=template&id=4bb1486a&"
import script from "./ClientJobs.vue?vue&type=script&lang=js&"
export * from "./ClientJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports